// 窗口大小变化
export function windowsRise(window, func) {
    window.onresize = () => {
        return (() => {
            typeof func == "function" && func();
        })()
    }
}